import { dateValidator } from '../dateValidator';
import { isValidChecksum, stripPin } from '../isValidPinNumber';
import { ValidationResult, ValidationRule } from '../types';

const isCorrectCoordinationNumberFormat = (coordinationNumber: string) => {
  // Given a 'YYYYMMDD-XXXX' formatted coordination number, capture the:
  // year part (4 digits)
  // month part (2 digits)
  // day part (2 digits)
  // and individual number part (4 digits)

  const regExp = /^(\d{4})(\d{2})(\d{2})(?:[\s()|-]?)(\d{4})$/;
  const match = coordinationNumber.match(regExp);

  if (match) {
    const [, yearPart, monthPart, dayPart, individualNumberPart] = match;
    // Check that the date is a valid date
    const actualDay = (Number(dayPart) - 60).toString().padStart(2, '0');
    const dateString = `${yearPart}-${monthPart}-${actualDay}`;
    if (dateValidator('')(dateString).error) {
      return false;
    }
    return regExp.test(coordinationNumber);
  }
  return false;
};

export const validateCoordinationNumber = (coordinationNumber: string) => {
  return (
    !coordinationNumber.slice(-4).startsWith('000') &&
    isCorrectCoordinationNumberFormat(coordinationNumber) &&
    isValidChecksum(stripPin(coordinationNumber))
  );
};

export const isValidCoordinationNumber =
  (errorMessage: string): ValidationRule =>
  (coordinationNumber: string): ValidationResult => {
    const isValid = validateCoordinationNumber(coordinationNumber);

    if (!isValid) {
      return { error: true, errorMessage };
    }

    return { error: !isValid, errorMessage };
  };
